export default __webpack_public_path__ + "static/media/heroBannerApp.fc33ac7b.png";